<div class="modal-header">
	<h3 class="modal-title" id="modal-title">{{msg}}</h3>
</div>
<div class="modal-footer text-right">
	<div class="button-wrapper">
		<button type="button" class="btn yes-button" (click)="close()">OK</button>
	</div>
</div>
